// This file implements functions of the "path" module of Node.js
// since the "path" module is not available in the browser.

/**
 * Patch of the "path.join" function of Node.js
 * It joins all given path segments together by using the "/" separator.
 * @param  {...any} args File path segments
 * @returns {string} The file path
 */
const join = (...args) => {
  return args.join("/");
};

module.exports = {
  join,
};
